module.exports = "/images/6_453ac2.png";